import memoizeWithWeakMap from './memoizeWithWeakMap';

// Largest fast integer in V8 (2 ** 31 - 1)
const MAX_FAST_INTEGER = 2_147_483_647;

function getRandomValue() {
  return Math.trunc(MAX_FAST_INTEGER * Math.random());
}

const getObjectId = memoizeWithWeakMap<unknown, object, number>(getRandomValue);

export default getObjectId;
